<template>
    <div id="page">

      <div class="container" style="margin-top: 5rem">
          <!-- 简历表单 -->
          <van-form @submit="onSubmit" class="form">
            <div class="infoInput">
                <h3>个人基本信息</h3>
                <van-field input-align="right" v-model="formData.name" name="name" label="姓名" placeholder="请输入"
                    :rules="[{ required: true }]"></van-field>
                <van-field input-align="right" class="err" v-model="formData.phone" name="phone" label="联系电话"
                    placeholder="请输入"
                    :rules="[{ required: true } , { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '请填写联系电话'}]">
                </van-field>
                <van-field right-icon="arrow" input-align="right" name="apply_post" readonly clickable label="申请岗位"
                    :value="formData.apply_post" placeholder="请选择" @click="apply_postPicker = true"
                    :rules="[{ required: true }]"></van-field>
                <van-field name="identity" label="候选人身份" input-align="right">
                    <template #input>
                        <van-radio-group v-model="identity" direction="horizontal">
                            <van-radio name="0" ref="radioC">社招人员
                                <template #icon="props">
                                    <img class="icon_img" :src="props.checked ? activeIcon : inactiveIcon" />
                                </template>
                            </van-radio>
                            <van-radio name="1">在校生
                                <template #icon="props">
                                    <img class="icon_img" :src="props.checked ? activeIcon : inactiveIcon" />
                                </template>
                            </van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field name="sex" label="性别" input-align="right">
                    <template #input>
                        <van-radio-group v-model="sex" direction="horizontal">
                            <van-radio name="0">男
                                <template #icon="props">
                                    <img class="icon_img" :src="props.checked ? activeIcon : inactiveIcon" />
                                </template>
                            </van-radio>
                            <van-radio name="1">女
                                <template #icon="props">
                                    <img class="icon_img" :src="props.checked ? activeIcon : inactiveIcon" />
                                </template>
                            </van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field right-icon="arrow" input-align="right" readonly clickable label="出生日期"
                    :value="formData.birthShow" name="birth" placeholder="请选择" @click="timePicker('birth')"
                    :rules="[{ required: true }]">
                </van-field>
                <van-field name="marital_status" label="婚姻状况" input-align="right">
                    <template #input>
                        <van-radio-group v-model="marital_status" direction="horizontal">
                            <van-radio name="0">未婚
                                <template #icon="props">
                                    <img class="icon_img" :src="props.checked ? activeIcon : inactiveIcon" />
                                </template>
                            </van-radio>
                            <van-radio name="1">已婚
                                <template #icon="props">
                                    <img class="icon_img" :src="props.checked ? activeIcon : inactiveIcon" />
                                </template>
                            </van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field input-align="left" label-width="100%" class="addr" v-model="formData.address"
                    name="address" label="现住地址" placeholder="请输入详细地址" :rules="[{ required: true }]"></van-field>
                <van-field class="required_no err" input-align="right" label-width="7.27rem"
                    v-model="past_salary" name="past_salary" label="过往薪资(税前)/元" placeholder="请输入"></van-field>
                <van-field input-align="right" class="err" label-width="7.27rem" v-model="formData.expect_salary"
                    name="expect_salary" label="期望薪资(税前)/元" placeholder="请输入"
                    :rules="[{ required: true }, { pattern: /^[1-9]\d*$/ , message: '请正确填写期望薪资' }]">
                </van-field>
                <van-field right-icon="arrow" input-align="right" label-width="16.2em" readonly clickable label="最快到岗时间"
                    :value="formData.arrive_time" name="arrive_time" placeholder="请选择"
                    @click="timePicker('arrive_time')" :rules="[{ required: true }]">
                </van-field>
            </div>
            <div class="infoInput">
                <h3>教育经历</h3>
                <van-field input-align="right" v-model="formData.school" name="school" label="学校名称"
                    placeholder="请输入" :rules="[{ required: true }]"></van-field>
                <van-field input-align="right" v-model="formData.profession" name="profession" label="所学专业"
                    placeholder="请输入" :rules="[{ required: true }]"></van-field>
                <van-field right-icon="arrow" input-align="right" name="education" readonly clickable label="学历"
                    :value="formData.education" placeholder="请选择" @click="educationPicker = true"
                    :rules="[{ required: true }]"></van-field>
                <van-field right-icon="arrow" input-align="right" readonly clickable label="就学时间"
                    :value="formData.school_begin_time_show" name="school_begin_time" placeholder="请选择"
                    @click="timePicker('school_begin_time')" :rules="[{ required: true }]">
                </van-field>
                <van-field right-icon="arrow" input-align="right" readonly clickable label="毕业时间"
                    :value="formData.graduation_time_show" name="graduation_time" placeholder="请选择"
                    @click="timePicker('graduation_time')" :rules="[{ required: true }]">
                </van-field>
            </div>
            <div class="infoInput">
                <div class="title_other">
                    <h3>工作经历</h3>
                    <p>（填写最近的三个经历）</p>
                </div>
                <van-collapse v-model="activeNames">
                    <van-collapse-item v-for="(job, index) in jobs" :key="index" :name="index">
                        <template #title>
                            <div class="title_job">
                                <div class="self_icon"></div> <span>工作经历 &nbsp;- &nbsp;</span><span v-text="index+1"></span>
                            </div>
                        </template>
                        <van-field class="required_no" input-align="right" v-model="job.company"
                            :name="job.company_name" label="公司" placeholder="请输入"></van-field>
                        <van-field class="required_no" input-align="right" v-model="job.post" :name="job.post_name"
                            label="职位" placeholder="请输入"></van-field>
                        <van-field class="required_no" right-icon="arrow" input-align="right" readonly clickable
                            label="在职时间" :value="job.job_begin_time" :name="job.job_begin_time_name"
                            placeholder="请选择" @click="timePicker(job.job_begin_time_name)">
                        </van-field>
                        <van-field class="required_no" right-icon="arrow" input-align="right" readonly clickable
                            label="离职时间" :value="job.job_leave_time" :name="job.job_leave_time_name"
                            placeholder="请选择" @click="timePicker(job.job_leave_time_name)">
                        </van-field>
                    </van-collapse-item>
                </van-collapse>
                <div class="add_job_btn">
                    <van-button type="primary" native-type="button" block @click="addJob">
                        <div class="add_icon">+</div> 新增工作经历
                    </van-button>
                </div>
            </div>
            <div class="btn">
                <van-button type="info" :class="opacitybtn" block native-type="submit">提交</van-button>
            </div>
        </van-form>
        <van-popup v-model="apply_postPicker" round position="bottom">
            <van-picker show-toolbar :columns="columns" @cancel="apply_postPicker = false"
                @confirm="apply_postOK" />
        </van-popup>
        <van-popup v-model="educationPicker" round position="bottom">
            <van-picker show-toolbar :columns="education_columns" @cancel="educationPicker = false"
                @confirm="educationOK" />
        </van-popup>
        <van-popup v-model="pickerShow" round position="bottom">
            <van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate"
                :max-date="maxDate" @cancel="pickerShow = false" @confirm="timeOK" />
        </van-popup>

        <van-dialog v-model="show" confirm-button-text="确定" @confirm="backUp">
            <template #title>
                <img class="dialog_title" src="../assets/img/word_has.png" alt="">
                <van-icon class="dialog_icon" name="cross" @click="backUp" />
            </template>
            <h5>简历投递成功</h5>
            <p class="dialog_content">如果您的简历符合我们的岗位要求，我们会尽快联系您来我司进行面试，请静候佳音。</p>
        </van-dialog>
        <!-- <%- include('../../layout/footer') %> -->
      </div>
    </div>
</template>

<script>
export default {
  name: "resume",
    data() {
        return {
            minDate: new Date(1960,1,1),
            maxDate: new Date(2045,11,31),
            currentDate: new Date,
            formData: {
                name: "",
                phone: "",
                arrive_time: "",
                apply_post: "",
                expect_salary: "",
                address: "",
                school: "",
                education: "",
                profession: "",
                school_begin_time_show: "",
                graduation_time_show: ""
            },
            past_salary: "",
            identity: "1",
            sex: "1",
            marital_status: "1",
            apply_postPicker: false,
            pickerShow: false,
            educationPicker: false,
            columns: [{
                text: "	数字互动娱乐事业部",
                children: [{
                    text: "广告销售"
                }, {
                    text: "KOL运营"
                }]
            },{
                text: "产品社群运营业务部",
                children: [{
                    text: "游戏运营"
                }, {
                    text: "游戏销售"
                }]
            }, {
                text: "游戏直播平台业务部",
                children: [{
                    text: "抖音直播运营"
                }, {
                    text: "抖音游戏主播"
                }, {
                    text: "微信社群客服"
                }, {
                    text: "直播场控"
                }]
            }, {
                text: "MCN业务部",
                children: [{
                    text: "视频剪辑(校招/社招)"
                }, {
                    text: "游戏短视频策划"
                }]
            }],
            education_columns: ["硕士及以上", "本科", "大专", "高中及以下"],
            file: "",
            fileList: [],
            inactiveIcon: require("../assets/img/choose.png"),
            activeIcon: require("../assets/img/chose.png"),
            birthShow: "",
            arriveTime: "",
            timePickerSelect: "",
            activeNames: ["0"],
            jobs: [{
                company: "",
                post: "",
                job_begin_time: "",
                job_leave_time: "",
                company_name: "company1",
                post_name: "post1",
                job_begin_time_name: "job_begin_time1",
                job_leave_time_name: "job_leave_time1"
            }],
            show: false
        }
    },
    computed: {
        opacitybtn: function() {
            let isEmpty = false;
            for (let data in this.formData) {
                if (this.formData[data] === "") {
                    isEmpty = true
                }
            }
            return isEmpty ? "opacitybtn_3" : "opacitybtn_10"
        }
    },
    methods: {
        onSubmit(values) {

            const that = this;
            values.apply_post = values.apply_post.join(",");

            console.log("submit", values);
            let params = new FormData;
            for (let data in values) {
                params.append(data, JSON.stringify(values[data]))
            }
            this.$ajax.post("/subresume",params,{
                headers: {
                "Content-Type": "multipart/form-data"
            },
            }).then(function(response) {
                console.log(response);
                that.show = true

            }).catch(function(error) {
                console.log(error)
            })
        },
        apply_postOK(value) {
            this.formData.apply_post = value;
            this.apply_postPicker = false
        },
        educationOK(val) {
            this.formData.education = val;
            this.educationPicker = false
        },
        timeOK(val) {
            const year = val.getFullYear();
            let month = val.getMonth();
            let day = val.getDate();
            if (month + 1 < 10) {
                month = month + 1;
                month = "0" + month
            }
            if (day < 10) {
                day = "0" + day
            }
            const dateShow = year + "/" + month + "/" + day;
            console.log(this.timePickerSelect);
            switch (this.timePickerSelect) {
            case "birth":
                {
                    this.formData.birthShow = dateShow
                }
                break;
            case "arrive_time":
                {
                    this.formData.arrive_time = dateShow
                }
                break;
            case "school_begin_time":
                {
                    this.formData.school_begin_time_show = dateShow
                }
                break;
            case "graduation_time":
                {
                    this.formData.graduation_time_show = dateShow
                }
                break;
            case "job_begin_time1":
                {
                    this.jobs[0].job_begin_time = dateShow
                }
                break;
            case "job_leave_time1":
                {
                    this.jobs[0].job_leave_time = dateShow
                }
                break;
            case "job_begin_time2":
                {
                    this.jobs[1].job_begin_time = dateShow
                }
                break;
            case "job_leave_time2":
                {
                    this.jobs[1].job_leave_time = dateShow
                }
                break;
            case "job_begin_time3":
                {
                    this.jobs[2].job_begin_time = dateShow
                }
                break;
            case "job_leave_time3":
                {
                    this.jobs[2].job_leave_time = dateShow
                }
                break;
            default:
                break
            }
            console.log(this.jobs);
            this.pickerShow = false
        },
        afterRead(file) {
            console.log(file);
            this.file = file
        },
        timePicker(val) {
            console.log(val);
            this.timePickerSelect = val;
            this.pickerShow = true
        },
        addJob() {
            if (this.jobs.length > 2) {
                return
            }
            this.jobs.push({
                company: "",
                post: "",
                job_begin_time: "",
                job_leave_time: "",
                company_name: "company1",
                post_name: "post1",
                job_begin_time_name: "job_begin_time1",
                job_leave_time_name: "job_leave_time1"
            });
            this.jobs.forEach((t,index)=>{
                t.company_name = "company" + (index + 1);
                t.post_name = "post" + (index + 1);
                t.job_begin_time_name = "job_begin_time" + (index + 1);
                t.job_leave_time_name = "job_leave_time" + (index + 1)
            }
            );
            console.log(this.jobs)
        },
        backUp() {
            window.location.href = "./deliverResume.html"
        }
    }
}
</script>

<style lang="scss" scoped>

.van-field__label::after {
  position: absolute;
  color: #ee0a24;
  font-size: 0.28rem;
  content: "*";
  margin-left: 0.1rem;
  margin-top: 0.05rem
}

.required_no>.van-field__label::after {
  display: none
}

.van-field__label {
  font-size: 0.28rem;
  font-family: "PingFang";
  color: rgb(39,39,39)
}

.van-divider {
  margin: 0.1rem 0
}

.van-button--info {
  font-size: 1rem;
  letter-spacing: 2px;
  font-family: "PingFang";
  color: rgb(255,255,255);
  font-weight: bold;
  background-color: #f2831b;
  width: 22rem;
  border-radius: 0.6rem;
  border: unset
}

.van-button--primary {
  font-size: 0.8rem;
  font-family: "PingFang";
  color: rgb(102,102,102);
  font-weight: bold;
  font-weight: bold;
  background-color: rgb(243,243,245);
  width: 22rem;
  height: 4.4rem;
  border-radius: 0.1rem;
  border: unset
}

.van-uploader__file {
  width: 6.9rem
}

.van-cell {
  padding: 0.8rem 16px;
}

.van-radio {
  overflow: unset;
  margin-left: .6rem;
}
.van-radio__label{
  margin-left: 2px;
}
.opacitybtn_3 {
  opacity: 0.3
}

.opacitybtn_10 {
  opacity: 1
}

.van-dialog {
  overflow: unset;
  border-radius: 0.1rem
}

.dialog_title {
  height: 1rem;
  width: 0.88rem;
  position: absolute;
  top: -0.5rem;
  left: 45%;
  z-index: 2002
}

.dialog_icon {
  position: absolute;
  top: 7%;
  left: 90%;
  font-weight: bold
}

.van-button--default {
  border-radius: 0.1rem;
  font-size: 0.32rem;
  font-family: "PingFang";
  color: rgb(242,131,27);
  font-weight: bold
}

h5 {
  font-size: 0.36rem;
  font-family: "PingFang";
  color: rgb(39,39,39);
  font-weight: bold;
  text-align: center
}

.van-dialog__content {
  display: flex;
  flex-direction: column;
  align-items: center
}

.dialog_content {
  font-size: 0.24rem;
  font-family: "PingFang";
  color: rgb(102,102,102);
  line-height: 1.5;
  text-align: center;
  width: 80%;
  margin-block-start:0;margin-block-end:1em}



a {
  text-decoration: none
}

.title {
  height: .85rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .2rem
}

.title .name {
  display: flex;
  align-items: center
}

.title .name span {
  color: #272727;
  font-size: .34rem;
  font-weight: bold;
  margin-right: .15rem
}

.title .name p {
  color: #8d8d8d;
  font-size: .24rem
}

.title a {
  color: #f2831b;
  font-size: .24rem;
  display: flex;
  align-items: center
}

.van-field__error-message {
  text-align: end
}

.van-field--error .van-field__control,.van-field--error .van-field__control::placeholder {
  color: rgb(192,194,200)
}

.van-field--error.van-cell::after {
  border-bottom: 1px solid #ee0a24
}

.van-field--error.van-cell--borderless::after,.van-field--error.van-cell:last-child::after {
  display: block
}


.page {
    max-width: 7.5rem
}

.top_1 {
    margin-left: 0.25rem;
    font-size: 1.24rem;
    font-family: "PingFang";
    color: rgb(153,153,153);
    font-weight: bold
}

.infoInput {
    margin-top: 0.2rem;
    padding-top: 0.36rem;
    background-color: #ffffff
}

.infoInput h3 {
    margin-left: 0.25rem;
    font-size: 1.4rem;
    font-family: "PingFang";
    color: rgb(39,39,39);
    font-weight: bold;
    margin-block-start:0;margin-block-end:0.36rem}

.icon_img {
    width: 0.8rem;
}

.add_icon {
    font-size: 0.4rem;
    font-weight: bolder;
    color: rgb(102,102,102);
    margin-right: 0.1rem;
    padding-bottom: 0.05rem
}

.van-button__text {
    display: flex;
    justify-content: center;
    align-items: center
}

.btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.45rem;
    background-color: #ffffff;
    padding-bottom: 0.6rem
}

.add_job_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 0.5rem
}

.addr {
    flex-wrap: wrap
}

.title_other {
    display: flex;
    align-items: flex-end
}

.title_other>p {
    font-size: 0.24rem;
    font-family: "PingFang";
    color: rgb(192,194,200);
    margin-block-start:0;margin-block-end:0.36rem;margin-inline-start:0px;margin-inline-end:0px}

.van-collapse-item__content {
    padding: unset
}

.title_job {
    font-size: 0.8rem;
    font-family: "PingFang";
    color: rgb(39,39,39);
    font-weight: bold;
    display: flex;
    align-items: center
}

.self_icon {
    width: 0.2rem;
    height: 0.8rem;
    background-color: rgb(242,131,27);
    margin-right: 0.2rem
}


</style>



// WEBPACK FOOTER //
// src/page/resume.vue